import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, Link, useLocation, useParams } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Navigation from './components/Navigation';
import { LogoTribe } from './components/charte/LogoTribe';
import Login from './pages/Login';
import Register from './pages/Register';
import Accueil from './pages/Accueil';
import Missions from './pages/Missions';
import NewMission from './pages/NewMission';
import MissionDetail from './pages/MissionDetail';
import Documents from './pages/Documents';
import Compte from './pages/Compte';
import Legal from './pages/Legal';
import Verify from './pages/Verify';
import MotDePasseOublie from './pages/MotDePasseOublie';

function AppLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="cadre">
      <Navigation />
      <main className="cadre__contenu" id="contenu">
        {children}
      </main>
    </div>
  );
}

const Prive: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <PrivateRoute>
    <AppLayout>{children}</AppLayout>
  </PrivateRoute>
);

/* Mentions légales : dans le cadre du portail pour un client connecté,
   seules avec le logo pour un visiteur. */
const PageLegale: React.FC = () => {
  const { isAuthenticated } = useAuth();
  if (isAuthenticated) return <AppLayout><Legal /></AppLayout>;
  return (
    <>
      <header className="ligne ligne--entre" style={{ padding: '12px 20px', background: 'var(--indigo)' }}>
        <LogoTribe largeur={28} surIndigo />
        <Link to="/connexion" className="bouton bouton--petit">Connexion</Link>
      </header>
      <main><Legal /></main>
    </>
  );
};

/* Anciennes adresses (liens enregistrés, emails déjà envoyés) : la requête suit. */
const Redirection: React.FC<{ vers: string }> = ({ vers }) => {
  const { search } = useLocation();
  return <Navigate to={`${vers}${search}`} replace />;
};

const AncienneFicheMission: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={`/missions/${id}`} replace />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/connexion" element={<Login />} />
          <Route path="/inscription" element={<Register />} />
          <Route path="/mot-de-passe-oublie" element={<MotDePasseOublie />} />
          {/* Lien envoyé par user-service dans l'email de confirmation : ne pas renommer. */}
          <Route path="/verify" element={<Verify />} />
          <Route path="/legal" element={<PageLegale />} />

          <Route path="/" element={<Prive><Accueil /></Prive>} />
          <Route path="/missions" element={<Prive><Missions /></Prive>} />
          <Route path="/missions/nouvelle" element={<Prive><NewMission /></Prive>} />
          <Route path="/missions/:id" element={<Prive><MissionDetail /></Prive>} />
          <Route path="/documents" element={<Prive><Documents /></Prive>} />
          <Route path="/compte" element={<Prive><Compte /></Prive>} />

          <Route path="/login" element={<Redirection vers="/connexion" />} />
          <Route path="/register" element={<Redirection vers="/inscription" />} />
          <Route path="/new-mission" element={<Redirection vers="/missions/nouvelle" />} />
          <Route path="/mission/:id" element={<AncienneFicheMission />} />
          <Route path="/factures" element={<Redirection vers="/documents" />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
